'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGridOn = function MdGridOn(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 13.4v-6.8h-6.8v6.8h6.8z m0 10v-6.8h-6.8v6.8h6.8z m0 10v-6.8h-6.8v6.8h6.8z m-10-20v-6.8h-6.8v6.8h6.8z m0 10v-6.8h-6.8v6.8h6.8z m0 10v-6.8h-6.8v6.8h6.8z m-10-20v-6.8h-6.8v6.8h6.8z m0 10v-6.8h-6.8v6.8h6.8z m0 10v-6.8h-6.8v6.8h6.8z m20-30c1.8 0 3.2 1.4 3.2 3.2v26.8c0 1.8-1.4 3.2-3.2 3.2h-26.8c-1.8 0-3.2-1.4-3.2-3.2v-26.8c0-1.8 1.4-3.2 3.2-3.2h26.8z' })
        )
    );
};

exports.default = MdGridOn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/grid-on.js
// module id = 1080
// module chunks = 36573943044255 79611799117203 213534597649335